import GatewayService from '../GatewayService.js';
var insights = new GatewayService('insights');

var createOrUpdateInsight = function createOrUpdateInsight(insight) {
  return insights.post('insight', insight);
};

var findInsight = function findInsight(params) {
  return insights.post('find', params);
};

var dismissInsight = function dismissInsight(insightKey) {
  return insights.put("insight/".concat(insightKey, "/dismiss"));
};

export default {
  createOrUpdateInsight: createOrUpdateInsight,
  dismissInsight: dismissInsight,
  findInsight: findInsight
};